export default {
  Ra: "invalid_api_key",
  Xa: "blacklisted",
  Ea: "no_device_identifier",
  Zh: "invalid_json_response",
  Vh: "empty_response",
  __: "sdk_auth_error",
};
